interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-9 min-w-9 rounded-md border px-3 text-sm transition-colors cursor-pointer ${
            p === current
              ? 'border-primary-500 bg-primary-500 text-background-50'
              : 'border-background-300 text-foreground-700 hover:border-primary-300'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}